import RteTestComponent from './components/RteTestComponent';

export {
  RteTestComponent
};

export default RteTestComponent;
